<div class="row">
  <div class="col-6">
    <h2>Door Status</h2>
  </div>

  <div class="col-sm-3">
    <input style="float: right; background-color: white; " type="text" placeholder="Search Store" nbInput
      [(ngModel)]="word" (keyup)="onFilterKeySearch()" />
  </div>
  <div class="col-3">
    <ng-select placeholder="Search Flag" [(ngModel)]="statusFlag" (change)="showList()" >
      <ng-option *ngFor="let f of flag" [value]="f.value">
        {{ f.name }}
      </ng-option>
    </ng-select>
  </div>

  <!-- <div *ngIf="role != 'admin'" class="col-sm-6">
      <input
        style="float: right; background-color: white"
        type="text"
        placeholder="Search Text"
        nbInput
        [(ngModel)]="word"
        (keyup)="onFilterKeySearch()"
      />
    </div> -->
  <!-- <div class="col-sm-2">
      <button
        *ngIf="role == 'admin'"
        type="button"
        class="btn btn-primary px-4"
        style="float: right"
        (click)="addStores()"
      >
        Add Store
      </button>
    </div> -->
</div>
<div class="col-12" style="margin-top: 20px">
  <nb-card>
    <nb-card-body>
      <table class="table text-center">
        <thead>
          <tr>
            <th scope="col">S.No.</th>
            <th scope="col">Logo</th>
            <th scope="col">Name</th>
            <th scope="col">Flag</th>
            <th scope="col">Check Time</th>
            <!-- <th scope="col">Address</th>
              <th scope="col">Latitude</th>
              <th scope="col">Longitude</th>
              <th scope="col">Visible</th>
              <th scope="col">Geofence</th>
              <th scope="col">View</th>
              <th scope="col">Action</th> -->
          </tr>
        </thead>


        <tbody>
          <tr *ngFor="
                let store of storeList
                  | paginate
                    : { itemsPerPage: 10, currentPage: page, totalItems: total };
                let i = index
              ">
            <td>{{ (page - 1) * count + i + 1 + (page - 1) * count }}</td>
            <td><img [src]='imageurl+store.logoImageUrl' height="50" /></td>
            <td>{{ store.storeName }}</td>
            <td>
              <span *ngIf="store.statusFlag == null">Not configured</span>
              <i class="fas fa-flag green-flag" *ngIf="store.statusFlag === 'true'"></i>
              <i class="fas fa-flag red-flag" *ngIf="store.statusFlag === 'false'"></i>
            </td>
            <td>{{ store.statusCheckTime| date : "dd/MM-YYYY HH:mm" }}</td>
            <!-- <td>{{ store.address }}</td>
              <td>{{ store.location.coordinates[1] }}</td>
              <td>{{ store.location.coordinates[0] }}</td>
              <td>{{ store.isVisible }}</td>
              <td>{{ store.geofenceCheck }}</td> -->
            <!-- <td>
                <i class="fas fa-qrcode me-2 point" (click)="open(store._id)"></i>
              </td> -->
            <!-- <td>
                <nb-icon
                  style="cursor: pointer"
                  (click)="editStore(store._id)"
                  class="right"
                  icon="edit-outline"
                ></nb-icon>
                <nb-icon
                  *ngIf="role == 'admin'"
                  style="cursor: pointer"
                  (click)="deletStore(store._id)"
                  class="right deleteIcon"
                  icon="trash-outline"
                ></nb-icon>
              </td> -->
          </tr>
        </tbody>
      </table>
      <pagination-controls class="pagination" [responsive]="true" (pageChange)="pageChanged($event)"
        previousLabel="Prev" nextLabel="Next"></pagination-controls>
    </nb-card-body>
  </nb-card>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner>